import { Container, Header, Segment, Grid, Image } from "semantic-ui-react";

export const Team = (props) => {
  return (
    <Segment id="team" vertical padded="very">
      <Container textAlign="center">
        <Header as="h1" textAlign="center">
          Team
        </Header>
        <Grid stackable>
          <Grid.Row columns={6}>
            <Grid.Column>
              <Grid.Row>
                <Image
                  src="./images/Cristina.png"
                  size="medium"
                  circular
                  as="a"
                  target="_blank"
                  href="https://cigonzalez.github.io/"
                />
              </Grid.Row>
              <Grid.Row
                as="a"
                target="_blank"
                href="https://cigonzalez.github.io/"
              >
                <p>Cristina González</p>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <Image
                  src="./images/Nicolas.png"
                  size="medium"
                  circular
                  as="a"
                />
              </Grid.Row>
              <Grid.Row>
                <p>Nicolás Ayobi</p>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <Image
                  src="./images/Isabela.png"
                  size="medium"
                  circular
                  as="a"
                />
              </Grid.Row>
              <Grid.Row>
                <p>Isabela Hernández</p>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <Image
                  src="./images/Jose.png"
                  size="medium"
                  circular
                  as="a"
                />
              </Grid.Row>
              <Grid.Row>
                <p>José Hernández</p>
              </Grid.Row>
            </Grid.Column>
            <Grid.Column>
            <Grid.Row>
              <Image
                src="./images/Jordi.png"
                size="medium"
                circular
                as="a"
                target="_blank"
                href="https://jponttuset.cat/"
              />
              </Grid.Row>
              <Grid.Row
                as="a"
                target="_blank"
                href="https://jponttuset.cat/"
              >
                <p>Jordi Pont-Tuset</p>
              </Grid.Row>  
            </Grid.Column>
            <Grid.Column>
              <Grid.Row>
                <Image
                  src="./images/Pablo.png"
                  size="medium"
                  circular
                  as="a"
                  target="_blank"
                  href="https://biomedicalcomputervision.uniandes.edu.co/"
                />
              </Grid.Row>
              <Grid.Row
                as="a"
                target="_blank"
                href="https://biomedicalcomputervision.uniandes.edu.co/"
              >
                <p>Pablo Arbeláez</p>
              </Grid.Row>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};
